import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewParametroEngorde = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'parametro_engorde',
        name: 'Parametros de engorde',
        component: ViewParametroEngorde,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
